module.exports = __webpack_public_path__ + "img/expired.8ce9c32e.png";